// extracted by mini-css-extract-plugin
export var homeFooter = "HomeV1-module--home-footer--tgDec";
export var playPauseWrapper = "HomeV1-module--playPauseWrapper--Mrt5g";
export var mainContent = "HomeV1-module--mainContent--DvlVJ";
export var sectionBtnExclusive = "HomeV1-module--sectionBtnExclusive--ppUCj";
export var btnExclusiveContent = "HomeV1-module--btnExclusiveContent--b6+MK";
export var btnIcon = "HomeV1-module--btnIcon--0aI4Y";
export var twitter = "HomeV1-module--twitter--n5G7g";
export var sectionGallery = "HomeV1-module--sectionGallery--32Vqw";
export var sectionForm = "HomeV1-module--sectionForm--iACDK";
export var bottomLogo = "HomeV1-module--bottomLogo--edYF9";
export var privacyPolicy = "HomeV1-module--privacyPolicy--AtXhe";